<script>
	const { openModal, closeModals, getFirstFocusableElement, getLastFocusableElement } = require('utilities');
	const Vue = require('vue');

	module.exports = {
		props: {
			id: {
				type: String,
				required: true
			},
			loading: {
				type: Boolean,
				default: false
			},
			centered: {
				type: Boolean,
				default: false
			},
			'has-form': {
				type: Boolean,
				default: false
			},
			wide: {
				type: Boolean,
				default: false
			},
			ok: {
				type: Boolean,
				default: false
			},
			'no-auto-close': {
				type: Boolean,
				default: false
			},
			closeable: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				open: false
			};
		},
		computed: {
			headerId() {
				return `${this.id}-header`;
			},
			loadingId() {
				return `${this.id}-loading`;
			},
			labelledbyId() {
				return this.loading ? this.loadingId : this.headerId;
			}
		},
		methods: {
			show: function (options) {
				openModal(this.$el, options);
			},
			hide: function () {
				closeModals(this.$el);
			},
			isVisible: function () {
				return window.getComputedStyle(this.$el).display !== 'none';
			},
			refocus(target = 'first') {
				const { modalWindow, modalContent } = this.$refs;

				const elementDict = {
					first: () => getFirstFocusableElement(modalWindow),
					last: () => getLastFocusableElement(modalWindow),
					entry: () => getFirstFocusableElement(modalContent)
				};
				const element = elementDict[target]();

				if (element) {
					element.focus();
				}
			},
			setOpen(open) {
				this.open = open;
			}
		},
		created() {
			this.$subscribe('modal-opened', modalId => {
				if (modalId === this.id) {
					this.setOpen(true);
				}
			});
			this.$subscribe('modal-closed', modalId => {
				if (modalId === this.id) {
					this.setOpen(false);
				}
			});
		},
		mounted() {
			Vue.nextTick(() => {
				let headerEl = this.$refs.modalHeader;
				if (headerEl && headerEl.children && headerEl.children.length) {
					headerEl.className += ' modal-content-header';
				}
			});
		},
		watch: {
			loading(newValue, oldValue) {
				this.refocus('entry');
			}
		}
	};
</script>
<template>
	<div
		v-bind:id="id"
		class="modal"
		tabindex="-1"
		data-modal-window
		@focus="refocus('entry')"
		:class="{
			'modal--active': open,
			'modal-loading-data': loading,
			'modal-no-auto-close': noAutoClose
		}">
		<button
			class="focus-capture hidden-visually"
			@focus="refocus('last')"></button>
		<div class="modal-container">
			<div class="modal-window">
				<div
					class="modal-window-wrap"
					v-bind:class="{ '-wide': wide }"
					ref="modalWindow"
					role="dialog"
					aria-modal="true"
					:aria-labelledby="labelledbyId"
					tabindex="-1">
					<slot name="top-tools">
						<button
							class="modal-close"
							v-if="closeable"
							@click.prevent="hide">
							<span aria-hidden="true">&times;</span><span class="hidden-visually"> Close</span>
						</button>
					</slot>
					<div
						class="modal-content-wrap"
						ref="modalContent">
						<section class="sidebar">
							<slot name="sidebar"> </slot>
						</section>
						<section class="modal-content">
							<header
								ref="modalHeader"
								:id="headerId">
								<slot name="header-container"> </slot>
							</header>
							<div
								class="modal-content-main"
								v-bind:class="{ '-centered': centered, '-form': hasForm }">
								<slot name="content"></slot>
								<button
									v-if="ok"
									class="button -centered"
									v-on:click.prevent="hide">
									OK
								</button>
							</div>
						</section>
					</div>
					<div
						:id="loadingId"
						class="modal-loading-content">
						Please wait, data is loading.
					</div>
				</div>
			</div>
		</div>
		<button
			class="focus-capture hidden-visually"
			@focus="refocus('first')"></button>
	</div>
</template>
